<div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start space-between">
  <div>
    <mat-icon class="msg-box-icon">{{getIcon()}}</mat-icon>
  </div>
  <div>
    <span class="msg-box-message">{{data.message}}</span>
  </div>
  <span fxFlex></span>
  <div>
    <button mat-button (click)="onBtnClick()">{{data.button}}</button>
  </div>
</div>
